export default __webpack_public_path__ + "static/media/pagopa-logo.37b9186a.png";